import React from "react";

import { RoutesWrapper } from "./routes/Wrapper";
import PreloadWrapper from "./routes/PreloadWrapper";
import { Toaster } from "sonner";

const App: React.FC = () => {
  return (
    <PreloadWrapper>
      <Toaster richColors position="top-right" />
      <RoutesWrapper />
    </PreloadWrapper>
  );
};

export default App;
